import { execute, gql, type ResultOf, type VariablesOf } from './financial-bff-gql'

export const GET_COMMISSIONING_STATUS = gql(`
  query GetCommissioningStatus($installation_id: ID!) {
    getCommissioningStatus(installation_id: $installation_id) {
      success
      message
      data {
        installation_id
        installation_status
        access_user
        customer_validation_requests {
          id
          status
          attempt_number
          initiated_at
        }
        monitorings {
          brand
          status
          plant_name
          commissioning_failure_reason
          installed_inverters {
            id
            serial_number
            model
            power_kw
            status
          }
        }
      }
    }
  }
`)

export type GetCommissioningStatusVariables = VariablesOf<typeof GET_COMMISSIONING_STATUS>
export type GetCommissioningStatusResult = ResultOf<typeof GET_COMMISSIONING_STATUS>
export type CommissioningStatusPayload = NonNullable<GetCommissioningStatusResult['getCommissioningStatus']>

export async function fetchCommissioningStatus(variables: GetCommissioningStatusVariables) {
  const data = await execute(GET_COMMISSIONING_STATUS, variables)
  return data.getCommissioningStatus
}
